import { CustomPlayButtonControl } from 'wistia/player_controls/custom_play_button_control'
import { BackwardControl, ForwardControl } from 'wistia/player_controls/custom_seek_control'
import { CustomPlayControl } from 'wistia/player_controls/custom_play_control'
import { Controller } from "@hotwired/stimulus"
import AdBlockerChecker from "utils/ad_blocker_checker"
import Quimbee from "quimbee"

export default class extends Controller {
  async initialize() {
    this.MAX_RETRIES = 30
    this.retryCount = 0

    const checker = new AdBlockerChecker(this.wistiaTestScriptURL())
    await checker.call(() => { this.setupCustomPlayer() }, this.displayBlockedVideoPlayerBanner)
  }

  setupCustomPlayer() {
    if (typeof(Wistia) === "object" && typeof(Wistia.defineControl) === "function") {
      // Global Wistia JS snippet is already loaded and defineControl function is defined
      Wistia.defineControl(CustomPlayButtonControl)
      Wistia.defineControl(BackwardControl)
      Wistia.defineControl(ForwardControl)
      Wistia.defineControl(CustomPlayControl)

    } else {

      const wistiaSnippetLoader = document.getElementById("wistiaSnippetLoader")
      if (wistiaSnippetLoader === null) {
        // Add Wistia snippet loader so it starts loading.
        const e = document.createElement("script")
        const s = document.getElementsByTagName("script")[0]
        e.src = this.wistiaScriptURL()
        e.type = "module"
        e.id = "wistiaSnippetLoader"
        e.setAttribute("defer", true)
        e.setAttribute("crossorigin", "anonymous")
        s.parentNode.insertBefore(e, s)
      }

      // The Wistia snippet loader is already added to the DOM,
      // but it might not be finished creating the Wistia object.
      this.retryCount += 1

      if (this.retryCount < this.MAX_RETRIES) {
        setTimeout(() => this.setupCustomPlayer(), 1000)
      }
    }
  }

  displayBlockedVideoPlayerBanner(error) {
    document.getElementById("strict_tracking_prevention_alert").classList.remove("hidden")
    document.getElementById("strict_tracking_prevention_alert_error").textContent = `${error.message}.`
    document.getElementById("strict_tracking_prevention_alert_error").classList.remove("hidden")
  }

  wistiaScriptURL() {
    return Quimbee.data.wistiaScriptURL || "//fast.wistia.net/assets/external/E-v1.js"
  }

  wistiaTestScriptURL() {
    return "//fast.wistia.com/embed/medias/sample.js"
  }
}
